import { Divider, IconDocument, Text } from 'braid-design-system';
import type { GraphQLInputObjectType } from 'graphql';
import { useLocation } from 'react-router';
import { InlineCode } from 'scoobie';

import { InputFieldDetails } from '../components/InputFieldDetails.tsx';
import { SchemaMarkdown } from '../components/SchemaMarkdown.tsx';
import { TypeSeenIn } from '../components/TypeSeenIn.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import { SchemaSection } from '#src/components/SchemaSection/SchemaSection.tsx';
import { sortGraphqlEntities } from '#src/utils/sort.ts';

export const InputObjectSchemaPage = ({
  inputObjectType,
  fieldName,
}: {
  inputObjectType: GraphQLInputObjectType;
  fieldName?: string;
}) => (
  <BasePage
    title={{
      children: <InlineCode weight="weak">{inputObjectType.name}</InlineCode>,
      htmlTitle: inputObjectType.name,
      stringTitle: inputObjectType.name,
      subHeading: (
        <Text
          icon={<IconDocument />}
          size="small"
          weight="medium"
          tone="secondary"
        >
          Input object
        </Text>
      ),
    }}
    breadcrumbs={[
      { href: '/schema', title: 'Schema' },
      { href: useLocation().pathname, title: inputObjectType.name },
    ]}
  >
    <SchemaMarkdown type={inputObjectType.name} />

    <Divider />

    <SchemaSection heading="Fields" wrapper="usage-table">
      {Object.entries(inputObjectType.getFields())
        .sort(sortGraphqlEntities)
        .map(([fieldNameKey, field]) => (
          <InputFieldDetails
            key={fieldNameKey}
            objectName={inputObjectType.name}
            highlight={fieldName === fieldNameKey}
            field={field}
          />
        ))}
    </SchemaSection>

    <Divider />

    <TypeSeenIn name={inputObjectType.name} />
  </BasePage>
);
